
<ng-container *ngIf="{
    row: columnData | async,
    adata: additionData | async
  } as $">
<span  *ngIf="$.row[$.adata.keyName];else dash">{{$.adata.pre?additionData.pre:""}}{{$.row[$.adata.keyName] }}{{$.adata.post?$.adata.post:""}}</span>
<ng-template #dash>-</ng-template>
</ng-container>
